/* eslint-disable @typescript-eslint/no-explicit-any */
import { createApi } from "@reduxjs/toolkit/query/react";
import baseQueryWithReauth from "./BaseQuery";

const sendMailApi = createApi({
  reducerPath: "sendMailApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["Mail"],
  endpoints: (builder) => ({
    sendMail: builder.mutation<any, { orderId: string }>({
      query: ({ orderId }) => ({
        url: `send-email/${orderId}`,
        method: "PUT",
      }),
    }),
    verifyEmailMutation: builder.mutation<any, { token: string }>({
      query: (body) => ({
        url: `verify-email`,
        method: "POST",
        body,
      }),
    }),
    resendEmailMutation: builder.mutation<any, any>({
      query: (body) => ({
        url: `resend-email`,
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useSendMailMutation,
  useVerifyEmailMutationMutation,
  useResendEmailMutationMutation,
} = sendMailApi;

export default sendMailApi;
